<template>
  <v-container class="margen_paginas pt-7" fluid>

    <!-- <pre>{{arrayEstadoInstalaciones}}</pre> -->

    <span v-for="instalacion in arrayEstadoInstalaciones" :key="instalacion.id">
      <div v-if="instalacion.zonas" style="min-width: 305px; display: inline-block; vertical-align: top;" class="mr-3 mb-3">
        <v-card width="100%" elevation="4" ripple @click="clickTarjetaAparcamiento(instalacion)">
          <v-card-text class="pa-3">
            <h3 class="mb-2">{{instalacion.nombre}}</h3>
            <div class="caption" v-for="(zona, indice) in instalacion.zonas" :key="indice">
              <v-progress-linear class="mb-1" rounded height="17" background-color="#f0f0f0" :value="zona.plazas_ocupadas * 100 / zona.total_plazas" :color="colorCadena(zona.descripcion)">
                <div class="flex d-flex">
                  <v-spacer />
                  <span style="font-size: 8pt">{{zona.descripcion}}</span>
                  <v-spacer />
                  <span style="font-weight: 700; margin-right: 5px">{{zona.total_plazas - zona.plazas_ocupadas}}</span>
                </div>
              </v-progress-linear>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </span>

    <div style="height: 8px"></div>

    <VisorEventosSAGA
      :titulo="$t ('Eventos (global)')"
      busqueda-rapida
      dense
    />
  </v-container>
</template>

<script>
import VisorEventosSAGA from "@/components/VisorEventosSAGA.vue";
import { cadenaAColor } from "@/util";

export default {
  components: { VisorEventosSAGA },
  data() {
    return {
      manejadorNotificacionesCambioEstado: null
    }
  },
  computed: {
    arrayEstadoInstalaciones() {
      // devolvemos un array de estado de las instalaciones filtrado
      let aux = [];
      Object.keys (this.$global.estadoInstalaciones).forEach ((id_ins) => {
        if (!this.$store.datos.id_instalacion_seleccionada || id_ins == this.$store.datos.id_instalacion_seleccionada)
          aux.push (this.$global.estadoInstalaciones [id_ins]);
      });
      return aux;
    }
  },
  methods: {
    colorCadena(cadena) {
      return cadenaAColor(cadena, 65, 75);
    },
    clickTarjetaAparcamiento(instalacion) {
      this.$store.guardar_preferencia ('id_instalacion_seleccionada', instalacion.id, null, 'controlRemoto');
      this.$router.push ({path: "/panel/sinopticoAparcamiento"});
    },
  },
  mounted() {
    this.$global.actualizarEstadoInstalaciones();
  }
};
</script>

<style>
</style>